import { Avatar, Box, Flex, Heading, Image } from "@chakra-ui/react";

interface NFTMintItemViewProps {
  name: string,
  image: string
  selected: boolean
}

const NFTMintItemView: React.FC<NFTMintItemViewProps> = (props) => {
  const { name, image, selected } = props;

  return (
    <>
      <Flex
        w="full"
        alignItems="center"
        justifyContent="center"
      >
        <Flex
          direction="column"
          justifyContent="center"
          alignItems="center"
          w="sm"
          mx="auto">

          <Image src={image} w={{ base: 24, md: 64 }} css={{
            border: selected ? '3px solid red' : '3px solid black',
          }} />

          <Box
            zIndex={2}
            bg="black"
            mt={-5}
            shadow="lg"
            rounded="sm"
            px={8}
            overflow="hidden"
          >
            <Heading
              py={2}
              textAlign="center"
              fontWeight="bold"
              fontSize={'sm'}
              textTransform="uppercase"
              color="white"
              letterSpacing={1}
            >
              {name}
            </Heading>
          </Box>
        </Flex>
      </Flex>
    </>
  );
};

export default NFTMintItemView;
